import { ApiHelper } from 'src/cad/common/services/api/api-helper';
import { Observable } from 'rxjs';
import { UserModelService } from 'src/cad/common/services/user/user-model-service';
import { AvailableCapacity } from 'src/cad/capacity-analysis/interfaces/available-capacity';
import { Injectable } from '@angular/core';

@Injectable()
export class AvailableCapacityApi{
  private readonly endpoint: string = 'capacity-analysis/available-capacity';
  constructor(
    private apiHelper: ApiHelper,
    private userModelService: UserModelService ) {
  }

  public getAvailableCapacity( physicalTypeCd: string, physicalName: string, physicalCd: string, dirOfFlow: string, effBeginDt: string, assetNbr: number, effEndDt: string): Observable<AvailableCapacity[]> {
    const reqObj = {
      physicalTypeCd,physicalName, physicalCd, dirOfFlow, effBeginDt, assetNbr: this.userModelService.getCurrentContext().assetNbr, effEndDt
    };
    return this.apiHelper.request(this.endpoint, { body: reqObj });
  }
}
